/** Arabic Privacy Policy copy (VizHacks public site). */
const privacyAr = {
  intro: {
    h2: "مقدمة",
    p: [
      'توضّح سياسة الخصوصية هذه كيف تجمع شركة VIZHACKS LTD («VizHacks» أو «نحن» أو «لنا» أو «خاصتنا») المعلومات الشخصية وتستخدمها وتخزّنها وتحميها عند استخدامكم موقعنا الإلكتروني والخدمات ذات الصلة («الخدمات»). تنطبق على الزائرين وعلى الأفراد الذين يُرسلون استفسارات أو طلبات خدمة عبر نماذجنا.',
      "نلتزم بحماية خصوصيتكم والتعامل مع البيانات بمسؤولية. يُرجى قراءة هذه السياسة بعناية. إن لم توافقوا عليها، يجب ألا تستخدموا الخدمات.",
    ],
  },
  controller: {
    h2: "مسؤول البيانات",
    p1: "المسؤول عن معالجة معلوماتكم الشخصية هو:",
    address: ["VIZHACKS LTD", "167–169 Great Portland Street, 5th Floor", "London, W1W 5PF, England"],
    p2: {
      before: "لطلبات تتعلق بالخصوصية، تواصلوا معنا عبر",
      linkLabel: "نموذج الاتصال",
      after: "أو البيانات الظاهرة في تذييل هذا الموقع.",
    },
  },
  collect: {
    h2: "المعلومات التي نجمعها",
    provided: {
      h3: "المعلومات التي تقدّمونها",
      p1: "عند إرسال رسالة اتصال أو طلب خدمة، قد نجمع المعلومات التي تُدخلونها، مثل:",
      items: [
        "الاسم وبيانات الاتصال (مثل البريد الإلكتروني ورقم الهاتف إن وُجد)",
        "اسم الشركة أو المؤسسة عند الاقتضاء",
        "حقول الدولة أو الموقع إن طلبها النموذج",
        "محتوى رسالتكم أو متطلباتكم أو وصف المشروع",
        "أي معلومات أخرى تختارون إدراجها في حقول نص حر",
      ],
      p2: "يُرجى عدم إرسال فئات خاصة من البيانات الشخصية (مثل معلومات صحية أو أرقام هويات رسمية أو ما شابه) ما لم نطلبها صراحةً. إن أدرجتمها طواعية، نعالجها فقط بقدر الحاجة للرد على استفساركم ووفق هذه السياسة.",
    },
    automated: {
      h3: "البيانات التقنية الآلية",
      p1: "عند استخدام الخدمات، قد تجمع خوادمنا وأنظمة الأمن معلومات تقنية تلقائيًا، بما في ذلك:",
      items: [
        "عنوان بروتوكول الإنترنت (IP)",
        "نوع المتصفح وإصداره (وكيل المستخدم)",
        "تاريخ ووقت الطلبات",
        "سجلات تشخيصية وأمنية مرتبطة بتشغيل الخدمة",
      ],
    },
    cookies: {
      h3: "ملفات تعريف الارتباط (الكوكيز)",
      p1: "لا نستخدم كوكيز غير أساسية أو تسويقية على هذا الموقع للأغراض المعتادة في لافتات الكوكيز. قد تظل التدابير التقنية الأساسية اللازمة لتشغيل الموقع والحفاظ على الأمان أو دعم وصول المشرفين سارية كما يوفّرها متصفحكم أو بيئة الاستضافة.",
    },
  },
  use: {
    h2: "كيف نستخدم معلوماتكم",
    p1: "نستخدم المعلومات الشخصية للأغراض التالية:",
    items: [
      "الرد على استفساراتكم وإدارة طلبات الخدمة",
      "تشغيل الخدمات وصيانتها وتحسينها",
      "تشغيل تحليل آلي أو شبه آلي لمحتوى الطلبات (مثل التلخيص أو التصنيف أو دعم مستشارينا) عند تفعيل هذه الميزات — وقد يشمل ذلك معالجة النص الذي أرسلتموه",
      "حماية أمن وسلامة أنظمتنا، بما في ذلك كشف إساءة الاستخدام أو الاحتيال أو محاولات الوصول غير المصرّح بها وغيرها من الأنشطة التي قد تضر بالخدمات أو بالمستخدمين الآخرين",
      "الامتثال للالتزامات القانونية وإنفاذ شروطنا",
    ],
    p2: "حيث يقتضي القانون المعمول به (مثل UK GDPR / GDPR)، نعتمد أسسًا قانونية مناسبة مثل تنفيذ عقد أو خطوات ما قبل التعاقد، والمصالح المشروعة (بما في ذلك الأمن وتحسين الخدمة)، والموافقة عند الاقتضاء.",
  },
  securityMonitoring: {
    h2: "الأمن ومنع الإساءة",
    p1: "نطبّق تدابير تقنية وتنظيمية تهدف إلى حماية المعلومات الشخصية. قد نسجّل ونحلّل بيانات تقنية وأنماط استخدام لاكتشف النشاط الضار، بما في ذلك محاولات التسلل أو أنماط حجب الخدمة أو إساءة استخدام النماذج العامة آلياً. تُنفَّذ هذه المعالجة لحماية بنيتنا التحتية والمستخدمين.",
  },
  sharing: {
    h2: "المشاركة والمعالجون",
    p1: "لا نبيع معلوماتكم الشخصية. قد نشارك البيانات مع مزوّدي خدمات موثوقين يساعدوننا في تشغيل الخدمات، على سبيل المثال:",
    items: [
      "مزوّدو الاستضافة والبنية التحتية",
      "أدوات البريد أو الاتصال المستخدمة للرد عليكم",
      "مزوّدون يدعمون التحليل الآلي أو المعالجة بمساعدة الذكاء الاصطناعي لمحتوى الطلبات، حيث نستخدم مثل هذه الميزات",
    ],
    p2: "تعالج هذه الجهات البيانات بتعليماتنا وبضمانات تعاقدية مناسبة لطبيعة المعالجة. قد نكشف أيضًا عن المعلومات إذا اقتضى القانون ذلك أو لحماية حقوقنا وسلامة الآخرين.",
  },
  transfers: {
    h2: "التحويلات الدولية",
    p1: "قد تُعالَج معلوماتكم في المملكة المتحدة وفي دول أخرى يعمل فيها مزوّدونا. عند نقل البيانات الشخصية خارج المملكة المتحدة أو المنطقة الاقتصادية الأوروبية، نستخدم ضمانات مناسبة كما يقتضي القانون المعمول به (مثل البنود التعاقدية الموحدة أو آليات مماثلة).",
  },
  retention: {
    h2: "الاحتفاظ",
    p1: "نحتفظ بالمعلومات الشخصية فقط للمدة اللازمة لتحقيق الأغراض الواردة في هذه السياسة، بما في ذلك الالتزامات القانونية أو المحاسبية أو التقارير. قد تختلف فترات الاحتفاظ بحسب طبيعة البيانات وعلاقتنا بكم.",
  },
  rights: {
    h2: "حقوقكم",
    p1: "بحسب موقعكم، قد تتمتعون بحقوق بموجب قوانين حماية البيانات، وقد تشمل الحق في الوصول أو التصحيح أو الحذف أو تقييد المعالجة، والحق في الاعتراض على معالجة معيّنة، وقابلية نقل البيانات، والحق في تقديم شكوى إلى سلطة رقابية.",
    p2: {
      before: "لممارسة هذه الحقوق، تواصلوا معنا عبر",
      linkLabel: "نموذج الاتصال",
      after: "أو البيانات في تذييل الموقع. قد نحتاج إلى التحقق من هويتكم قبل الرد.",
    },
  },
  children: {
    h2: "الأطفال",
    p1: "الخدمات لا تستهدف الأطفال دون السن التي يُطلب فيها موافقة ولي الأمر لمعالجة البيانات في نطاق اختصاصكم. لا نجمع عن علم معلومات شخصية من أطفال في هذا السياق.",
  },
  changes: {
    h2: "تغييرات هذه السياسة",
    p1: 'قد نحدّث سياسة الخصوصية هذه من وقت لآخر. يُحدَّث تاريخ «آخر تحديث» أعلى هذه الصفحة عند إجراء تغييرات جوهرية. ننصحكم بمراجعة هذه الصفحة دوريًا.',
  },
  related: {
    h2: "شروط ذات صلة",
    p1: {
      before: "",
      termsLink: "شروط الاستخدام",
      after: "تنظم استخدام الموقع والخدمات ويُنصح بقراءتها مع هذه السياسة.",
    },
  },
};

export default privacyAr;
